<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<!--
Note: this field is not currently using reative forms
-->
<div class="rich_wrapper">
  <div class="flex-row-top-right">
    <div class="fill-remaining-space">
      <!-- All modes -->
      <div class="flex-row-top-right">
        <!-- *ngIf="(this.Mode === 'preview') || (this.Mode === 'instance')" -->
        <div class="fill-remaining-space">
          @if (this.DisplayName) {
            <div class="field-label">
              @if (!this.FormField.required) {
                <span>
                  <span>{{this.DisplayName}}</span>
                </span>
              }
              @if (this.FormField.required) {
                <span>
                  <span>{{this.DisplayName}}</span>&nbsp;<span style="color: #EF0000;">*</span>
                </span>
              }
              @if (ShowHistoryLink) {
                <span>
                  <a style="cursor:pointer;" (click)="onHistoryClick($event)" class="noprint">History</a>
                  <button mat-button (click)="this.exportRichTextHistoryClicked()">
                    <mat-icon style="margin-bottom: 28px;" aria-hidden="false" aria-label="Download history" class="export-grid-data-mat-icon" title="Download history" svgIcon="microsoft-excel"></mat-icon>
                  </button>
                </span>
              }
            </div>
          }
          @if (this.HasInstructions) {
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          }

          @if (ShowHistory) {
            <div class="history">
              <app-form-instance-history [historyItem]="this.FormInstanceElementForHistory"
                [formInstance]="this.formInstance"
                [showHistoryForRichTextField]="true"
                (view)="onViewVersion($event)"
                (restore)="onVersionRestore($event)"
              (close)="onCloseHistory($event)"></app-form-instance-history>
            </div>
          }

          @if (VersionToShow) {
            <div class="version">
              <strong>{{versionToShow.getExtraInfo()}}</strong>
              <div [innerHtml]="versionToShow.value | safe: 'html'"></div>
            </div>
          }

          @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
            <kendo-editor name="kendo-editor"
              [formControl]="this.FormControl"
              [pasteCleanupSettings]="pasteSettings"
              (paste)="onPaste($event)"
              style="height: 100%;">
              <kendo-toolbar>
                @if (includeSimpleTextButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-colorpicker kendoEditorForeColor [paletteSettings]="{palette:'basic'}"></kendo-toolbar-colorpicker>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-colorpicker kendoEditorBackColor [paletteSettings]="{palette:'basic'}"></kendo-toolbar-colorpicker>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlightRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeBulletButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                @if (includeAllButtons()) {
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                }
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button title="Copy Formatted"
                    (click)="CopyToClipboardFormatted()"
                    [svgIcon]="clipboardHtmlIcon"
                    showIcon="always">
                  </kendo-toolbar-button>
                  <kendo-toolbar-button title="Copy Plain"
                    (click)="CopyToClipboardPlain()"
                    [svgIcon]="copyIcon"
                    showIcon="always">
                  </kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
              </kendo-toolbar>
            </kendo-editor>
            <span [ngClass]="MaxLengthExceededClass">{{MaxLengthMessage}}</span>
          }
          <!-- Note:  Keep the ngModel approach around just in case -->
          <!-- <ng-container *ngIf="false">
          <kendo-editor name="kendo-editor"
            [(ngModel)]="this.HtmlValue"
            style="height: 100%;"
            [resizable]="true"
            [iframeCss]="{ content: this.getEditorCssDefaults() }">
            <kendo-toolbar [ngClass]="this.ReadOnly ? 'hide-toolbar' : ''">
              <kendo-toolbar-buttongroup *ngIf="includeSimpleTextButtons()">
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup *ngIf="includeAllButtons()">
                <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-dropdownlist *ngIf="includeAllButtons()" kendoEditorFormat></kendo-toolbar-dropdownlist>
              <kendo-toolbar-dropdownlist *ngIf="includeAllButtons()" kendoEditorFontSize></kendo-toolbar-dropdownlist>
              <kendo-toolbar-dropdownlist *ngIf="includeAllButtons()" kendoEditorFontFamily></kendo-toolbar-dropdownlist>
              <kendo-toolbar-colorpicker *ngIf="includeAllButtons()" kendoEditorForeColor [paletteSettings]="{palette:'basic'}"></kendo-toolbar-colorpicker>
              <kendo-toolbar-colorpicker *ngIf="includeAllButtons()" kendoEditorBackColor [paletteSettings]="{palette:'basic'}"></kendo-toolbar-colorpicker>
              <kendo-toolbar-buttongroup *ngIf="includeAllButtons()">
                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlightRightButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup *ngIf="includeBulletButtons()">
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-editor-insert-table-button *ngIf="includeAllButtons()"></kendo-editor-insert-table-button>
              <kendo-toolbar-buttongroup *ngIf="includeAllButtons()">
                <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup *ngIf="includeAllButtons()">
                <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup *ngIf="includeAllButtons()">
                <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
            </kendo-toolbar>
          </kendo-editor>
        </ng-container> -->
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </div>
    </div>
  </div>
  <div [ngClass]="{'tooltip-with-instructions':(FormField.instructionsText != null && FormField.instructionsText != '')}">
    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
  </div>
</div>
</div>
